import React from 'react';
import { Icon } from 'panamera-react-ui';
import { Link } from 'react-router-dom';
import { withComponentDependency } from "../../ComponentDependency/withComponentDependency";
import useSearcBarFunctionality from "./useSearchBarFunctionality";
var css = {
  "header": "oalp-2m9S8",
  "header__title": "oalp-282r7",
  "searchBar": "oalp-kiybY",
  "searchBar__textbox": "oalp-1ZwNz",
  "searchBar__placeholder": "oalp-10F14",
  "headerText": "oalp-3xomb",
  "backButton": "oalp-1mwJt",
  "closeBtn": "oalp-3MIt-"
};
import { EVALUATION_STATES, EVALUATION_ROUTES, USI, EVALUATION_STATES_TRACKING } from "../../Constants/evaluation";
import { REQUEST_ORIGINS, REQUEST_ORIGIN } from "../../Constants/requestOrigins";
import SessionStorageHelper from "../../Utils/SessionStorageHelper";
import UserSession from "../../Utils/UserSession";
import { trackingHelper } from "../../Helpers/trackingHelper";
import { TRACKING_EVENTS } from "../../Constants/trackingEvents";
var metadataDefault = {
  text: null,
  isShowBackIcon: false,
  headerStyle: {},
  textStyle: {},
  backIconStyle: {},
  backIconSize: 17,
  headerImageStyles: {
    image: {},
    wrapper: {}
  },
  showCloseIcon: false,
  closeIconStyles: {},
  closeIconSize: 20,
  isL2Qrevamp: false
};
var DEFAULT_LOGO_PROPS = {
  ALT: 'OLX Autos Logo',
  WIDTH: 112,
  HEIGHT: 25
};
export var OLXAutosHeader = function OLXAutosHeader(props) {
  var _props$data = props.data,
    searchBar = _props$data.searchBar,
    _props$data$logo = _props$data.logo,
    url = _props$data$logo.url,
    cta = _props$data$logo.cta,
    _props$data$logo$widt = _props$data$logo.width,
    width = _props$data$logo$widt === void 0 ? DEFAULT_LOGO_PROPS.WIDTH : _props$data$logo$widt,
    _props$data$logo$heig = _props$data$logo.height,
    height = _props$data$logo$heig === void 0 ? DEFAULT_LOGO_PROPS.HEIGHT : _props$data$logo$heig,
    _props$data$logo$alt = _props$data$logo.alt,
    alt = _props$data$logo$alt === void 0 ? DEFAULT_LOGO_PROPS.ALT : _props$data$logo$alt,
    headerImage = _props$data.headerImage,
    SearchOverlay = props.SearchOverlay,
    metadata = props.metadata,
    handleIconClick = props.handleIconClick,
    location = props.location,
    track = props.track,
    locationId = props.locationId,
    origin = props.origin,
    landingURLSearch = props.landingURLSearch;
  var _useSearcBarFunctiona = useSearcBarFunctionality(),
    onSearchBarTap = _useSearcBarFunctiona.onSearchBarTap,
    isSearchOverlayOpen = _useSearcBarFunctiona.isSearchOverlayOpen,
    handleCloseToggleSearchOverlay = _useSearcBarFunctiona.handleCloseToggleSearchOverlay;
  var _ref = metadata || {},
    style = _ref.style,
    _ref$header = _ref.header,
    _ref$header2 = _ref$header === void 0 ? metadataDefault : _ref$header,
    headerText = _ref$header2.text,
    headerStyle = _ref$header2.headerStyle,
    isShowBackIcon = _ref$header2.isShowBackIcon,
    textStyle = _ref$header2.textStyle,
    backIconStyle = _ref$header2.backIconStyle,
    headerImageStyles = _ref$header2.headerImageStyles,
    backIconSize = _ref$header2.backIconSize,
    showCloseIcon = _ref$header2.showCloseIcon,
    closeIconSize = _ref$header2.closeIconSize,
    closeIconStyles = _ref$header2.closeIconStyles,
    isL2Qrevamp = _ref$header2.isL2Qrevamp;
  function getValuationStatus(isUSIPresentInPathName) {
    if (isUSIPresentInPathName === USI) {
      return EVALUATION_STATES.VALUATION_DONE;
    }
    return EVALUATION_STATES.VALUATION_STARTED;
  }
  function getRoute(isUSIPresentInPathName) {
    if (isUSIPresentInPathName === USI) {
      return "".concat(EVALUATION_ROUTES.SELF_INSPECTION, "?from=si_cta");
    }
    return EVALUATION_ROUTES.VALUATION_FLOW;
  }
  function handleBackIconClick() {
    var isUSIPresentInPathName = location === null || location === void 0 ? void 0 : location.pathname;
    var SECTION_TO_REDIRECT = {
      name: 'phone',
      valuationStatus: getValuationStatus(isUSIPresentInPathName),
      route: getRoute(isUSIPresentInPathName)
    };
    if (handleIconClick) {
      handleIconClick(UserSession.getUserEvaluationState(), SECTION_TO_REDIRECT);
      trackingHelper({
        eventName: TRACKING_EVENTS.VALUATION_EDIT_CAR_DETAILS_ERROR,
        track: track,
        locationId: locationId,
        origin: origin,
        landingURLSearch: landingURLSearch,
        select_from: EVALUATION_STATES_TRACKING.VALUATION_COMPLETE
      });
      if (isShowBackIcon && !isL2Qrevamp) {
        SessionStorageHelper.setItem(REQUEST_ORIGIN, REQUEST_ORIGINS.LANDING_PAGE);
      }
    }
  }
  function handleCloseClick() {
    if (handleIconClick) {
      trackingHelper({
        eventName: TRACKING_EVENTS.VALUATION_TAP_CLOSE,
        track: track,
        locationId: locationId,
        origin: origin,
        landingURLSearch: landingURLSearch,
        select_from: EVALUATION_STATES_TRACKING.VALUATION_COMPLETE
      });
      handleIconClick(UserSession.getUserEvaluationState());
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: css.header,
    style: style
  }, headerText ? /*#__PURE__*/React.createElement("div", {
    className: css.headerText,
    style: headerStyle
  }, isShowBackIcon && /*#__PURE__*/React.createElement("span", {
    className: css.backButton,
    onClick: handleBackIconClick,
    style: backIconStyle
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "back",
    color: "primary",
    size: backIconSize,
    "data-aut-id": "icon"
  })), headerImage && headerImage.url && /*#__PURE__*/React.createElement("span", {
    className: css.headerImage,
    style: headerImageStyles === null || headerImageStyles === void 0 ? void 0 : headerImageStyles.wrapper
  }, /*#__PURE__*/React.createElement("img", {
    src: headerImage.url,
    alt: headerImage.alt
  })), /*#__PURE__*/React.createElement("span", {
    style: textStyle
  }, headerText), showCloseIcon && /*#__PURE__*/React.createElement("button", {
    className: css.closeBtn,
    style: closeIconStyles,
    onClick: handleCloseClick
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "cross",
    color: "primary",
    size: closeIconSize,
    "data-aut-id": "icon"
  }))) : /*#__PURE__*/React.createElement("div", {
    className: css.header__title
  }, cta ? /*#__PURE__*/React.createElement(Link, {
    to: cta
  }, /*#__PURE__*/React.createElement("img", {
    src: url,
    alt: alt,
    width: width,
    height: height
  })) : /*#__PURE__*/React.createElement("img", {
    src: url,
    alt: alt,
    width: width,
    height: height
  })), searchBar && /*#__PURE__*/React.createElement("div", {
    className: css.searchBar
  }, /*#__PURE__*/React.createElement("div", {
    className: css.searchBar__textbox,
    onClick: onSearchBarTap
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "search",
    color: "primary",
    size: 17,
    "data-aut-id": "icon"
  }), searchBar.placeHolderText && /*#__PURE__*/React.createElement("span", {
    className: css.searchBar__placeholder
  }, searchBar.placeHolderText)), isSearchOverlayOpen && SearchOverlay && /*#__PURE__*/React.createElement(SearchOverlay, {
    onClose: handleCloseToggleSearchOverlay,
    defaultTerm: ""
  })));
};
export default withComponentDependency(OLXAutosHeader);